import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { ClarityService } from './clarity.service';

export function provideClarity(enabled?: boolean, key?: string): EnvironmentProviders[] {
  return enabled && key
    ? [
      provideAppInitializer(() => inject(ClarityService).initialize(key)),
    ]
    : [];
}
